import { theme } from '../../Theme';
import { css } from 'emotion';

export const EztradStyling = css`
  .page-header {
    h1 {
      font-weight: 700;
      font-size: 2.75rem;
      color: ${theme.colors.almostBlack};
      text-transform: uppercase;
      font-feature-settings: normal;
    }
    .page-description {
      line-height: 171%;
      letter-spacing: 0.03em;
    }
  }

  ${theme.below.md} {
    .page-header h1 {
      font-size: 2rem;
    }
  }
`;
